import React from 'react';

type Doctor = {
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  price: number;
  originalPrice?: number;
  photoUrl: string;
  is_online?: boolean; // Optional property to indicate if the doctor is online
};

interface DoctorCardProps {
  doctor: Doctor;
  onConsult?: () => void;
}


const DoctorCard: React.FC<DoctorCardProps> = ({ doctor, onConsult }) => {
  return (
    <div className="flex items-center bg- {} p-4 rounded-xl shadow mb-4">
      {/* Foto */}
      <div className="relative mr-4">
        <img 
          src={doctor.photoUrl} 
          alt={doctor.name} 
          className="w-16 h-16 rounded-lg object-cover" 
        />
        <span
          className={`w-3 h-3 rounded-full absolute bottom-0 right-0 border-2 border-white ${
            doctor.is_online ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
      </div>

      {/* Info Dokter */}
      <div className="flex-1">
        <h4 className="font-semibold">{doctor.name}</h4>
        <p className="text-sm text-gray-500">{doctor.specialization}</p>
        <div className="text-sm text-gray-600 flex gap-2 mt-1">
          <img src="/app-icons/briefcase.svg" alt="Years" className="w-4 h-4" /> <span>{doctor.years} years</span>
          <img src="/app-icons/thumb-up.svg" alt="thumb" className="w-4 h-4" /> <span>{doctor.rating}%</span>
        </div>
      </div>

      {/* Tombol Konsultasi */}
      <div className="flex items-center ml-4">
        <button 
          className="bg-morning-300 text-white px-4 py-1 rounded-full text-sm"
          onClick={onConsult}

        >
          { doctor.is_online ? "Konsultasi" : "Jadwalkan"}
        </button>
      </div>
    </div>

  );
};

export default DoctorCard;
